<template>
  <Form @submit="onSubmit" :validation-schema="schema">
    <div class="flex justify-between w-full gap-x-2">
      <div class="w-full">
        <label class="cursor-pointer">
          <div class="flex items-center justify-between p-4 border border-gray-100 rounded-md" :class="{ ' border-slate-600': tempSelection === 0 }">
            <div class="block text-sm font-medium text-gray-700 dark:text-white">False</div>
            <Field @click="tempSelection = 0" name="selectedOption" value="false" type="radio" class="w-5 h-5 border-gray-300 text-slate-600 focus:ring-slate-500" />
          </div>
        </label>
      </div>
      <div class="w-full">
        <label class="cursor-pointer">
          <div class="flex items-center justify-between p-4 border border-gray-100 rounded-md" :class="{ ' border-slate-600': tempSelection === 1 }">
            <div class="block text-sm font-medium text-gray-700 dark:text-white">True</div>
            <Field @click="tempSelection = 1" name="selectedOption" value="true" type="radio" class="w-5 h-5 border-gray-300 text-slate-600 focus:ring-slate-500" />
          </div>
        </label>
      </div>
    </div>
    <error-message class="mt-1 text-sm text-red-500" name="selectedOption"></error-message>

    <TaskSubmitButton :cta="'Submit'" :correct="answer.correct" @skip="$emit('skip', $event)" />
  </Form>
</template>

<script>
import { Form, Field, ErrorMessage } from "vee-validate";
import TaskSubmitButton from "../task/TaskSubmitButton.vue";
import { ref } from "vue";
export default {
  components: {
    Form,
    Field,
    ErrorMessage,
    TaskSubmitButton,
  },

  props: {
    solution: Array,
  },

  setup(props, { emit }) {
    const answer = ref({
      item: null,
      correct: null,
    });
    const schema = {
      selectedOption: (value) => {
        if (value) {
          return true;
        }
        return "Please select your answer.";
      },
    };

    const tempSelection = ref(null);
    function onSubmit(e) {
      const correct = props.solution[0].toString().toLowerCase() === e.selectedOption.toLowerCase() ? true : false;

      answer.value = {
        item: e.selectedOption,
        correct: correct,
      };

      emit("answer", answer.value);
    }

    return { schema, answer, onSubmit, tempSelection };
  },
};
</script>
